import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async';
function Transit() {
  return (
    <>
    <Helmet>
    <title>
        Transit Inspection & Design Services UAE | Cable & Pipe Penetration | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides professional transit inspection and design services in the UAE for cable and pipe penetrations across industries, ships, data centres, construction and process plants, including fireproof, watertight and EMC requirements."
    />

    <meta
        name="keywords"
        content="transit inspection UAE, transit design UAE, cable penetration inspection UAE, pipe penetration inspection UAE, cable transit system UAE, MCT design UAE, cable penetration design UAE, pipe penetration design UAE, watertight cable transit UAE, fireproof cable penetration UAE, EMC cable transit UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/transit-inspection"
    />

    <meta
        property="og:title"
        content="Transit Inspection & Design Services UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Professional inspection and design of cable and pipe penetrations with fireproof, watertight and EMC requirements for industrial and infrastructure applications."
    />

    <meta
        property="og:url"
        content="https://saig.me/transit-inspection"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
      <div className='newbanner-about newbanner-about2'>
        <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
          <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Transit - Inspection & Design</h6>
          {/* <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Industrial Labeling & Tagging Solutions */}
          {/* </p> */}
        </div>
      </div>

         <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Transit - Inspection &amp; Design</h2>
  <div className='line'></div>
                         <h3 className='text-justify'>We offer site inspection of cable and pipe penetrations in industry, ships, data-centres, construction,
process plants etc. Analyse the requirements with respect to class requirements, fire-proof,
watertight, EMC requirements etc and using the MCT software we design the system that is best
suited to your needs with minimal risk. </h3>

               </div>
               </div>
      <div className='service-details-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[50px]'>
        <div className='service-details-div-left'>
          <img src='/assets/new ser2.png' style={{width:'400px'}} alt='' />
        </div>
        <div className='service-details-div-right font-kanit'>
         <ul className="mt-4 grid grid-cols-1 md:grid-cols-1 ">
  {[
    "Professional approach",
    "Vetted solution",
    "Documentation support",
    "Elimination of wrong sizing",
    "Pre-designed solution",
    "Installation verification",
   
  ].map((item, i) => (
    <li
      key={i}
      className="flex items-start gap-3 rounded-lg bg-white px-4 transition"
    >
      <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
      <span className="text-gray-700 text-[18px] leading-relaxed aplus">
        {item}
      </span>
    </li>
  ))}
</ul>
         <Link to='/services'>

            <button className='backbtn'>
              Back To Services
            </button>
</Link>
        </div>
      </div>
      {/* <div className='service-details-div2 font-kanit max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] mb-[40px]'>
        <div className='grid lg:grid-cols-2 grid-cols-1 gap-[30px]'>
          <div className='ser-box'>


            <h4>EMC (Electromagnetic Compatibility) Protection</h4>

            <p>EMC protection ensures that electrical and electronic devices operate without interference from or to other equipment. Our enclosures are designed with shielding and grounding provisions to minimize electromagnetic disturbances, making them ideal for sensitive control and communication systems.</p>
          </div>
          <div className='ser-box'>

            <h4>Socket Combination Boxes</h4>

            <p>These are customizable power distribution units that combine multiple socket outlets in a single enclosure. Commonly used on industrial sites, they offer flexible, safe, and organized power access for machines, tools, and temporary setups.</p>
          </div>
          <div className='ser-box'>

            <h4>Wiring & Installation</h4>


            <p>We provide complete internal wiring and component installation within the enclosures as per the client’s specifications. This includes routing, terminating, and testing all electrical connections for a ready-to-use solution, reducing on-site work and installation time.</p>

          </div>
          <div className='ser-box'>

            <h4>Emergency Push Button</h4>
            <p>Designed for safety-critical applications, these buttons allow users to immediately shut down equipment or stop processes during emergencies. Enclosed in rugged housings, they are easily accessible, clearly marked, and compliant with safety standards.</p>
          </div>
          <div className='ser-box'>

            <h4>Terminal Junction Boxes</h4>
            <p>These boxes provide a secure and organized environment for connecting, branching, and protecting electrical wires. They simplify cable management and troubleshooting while offering protection from dust, moisture, and mechanical stress.</p>
          </div>
          <div className='ser-box'>

            <h4>Control Stations</h4>
            <p>Control stations house switches, indicators, and operator controls in a compact and durable enclosure. They are used to manage and monitor machines or processes, and can be customized based on operational needs — including single or multiple controls.

            </p>
          </div>
          <div className='ser-box'>

            <h4>Push Button Stations</h4>
            <p>These are enclosures equipped with one or more push buttons to start, stop, or control specific functions of machinery or systems. They are built to withstand industrial conditions and can include features like illuminated indicators or labels for easy identification.
            </p>
          </div>

        </div>

      </div> */}
    </>
  )
}

export default Transit